import { render } from "./AdminAffiliate.vue?vue&type=template&id=cf411f58"
import script from "./AdminAffiliate.vue?vue&type=script&lang=js"
export * from "./AdminAffiliate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__